export const HOME_COLUMN = '1';
export const DRAW_COLUMN = 'X';
export const AWAY_COLUMN = '2';
export const TWO_WAY_COLUMN_LENGTH = 2;
export const THREE_WAY_COLUMN_LENGTH = 3;
export const FIRST_SELECTION_INDEX = 0;
export const SECOND_SELECTION_INDEX = 1;
export const THIRD_SELECTION_INDEX = 2;

export const CSS_CLASS_BLOCK_NAME = 'bb-sport-event';
export const SELECTION_WRAPPER_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__selection-wrapper`;
export const SELECTION_WRAPPER_CSS_FORCE_SUSPENDED = `${SELECTION_WRAPPER_CSS_CLASS_BLOCK_NAME}--force-suspended`;
